import React, { createContext, useContext, useEffect, useState } from "react";

const TokenCallContext = createContext();

export const TokenCallProvider = ({ children }) => {
  const data = "Hii Token"
  const validNewCustomer = localStorage.getItem('validNewCustomer') === 'true'
  const validWithOTP = localStorage.getItem('validWithOTP') === 'true'
  const [dataFetchSuccess, setDataFetchSuccess] = useState(false)
  const [currentUrl, setCurrentUrl] = useState(sessionStorage.getItem("currentUrl") || "");
  useEffect(() => {
    const handleStorageChange = () => {
      const updatedUrl = sessionStorage.getItem("currentUrl");
      if (updatedUrl !== currentUrl) {
        setCurrentUrl(updatedUrl);
      }
    };

    // Update state on storage change
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [currentUrl]);

  const fetchToken = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/auth/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch token');
      }

      const data = await response.json();
      //   setTokenData(data.access_token);
      localStorage.setItem("auth-token", data.access_token);
    } catch (error) {
      // console.log("Erron", error)
    }
  };
  useEffect(() => {
      fetchToken()
    },[])

  const fetchDataFromCache = async () => {
    try {
      const cache = await caches.open('user-data-cache');
      const request = new Request('/user-data');
      const cachedResponse = await cache.match(request);

      if (cachedResponse) {
        const data = await cachedResponse.json();
        sessionStorage.setItem('userData', JSON.stringify(data));
        return data;
      } else {
        // console.log('Data not found in cache.');
        return {};
      }
    } catch (err) {
      console.error('Failed to fetch data from cache:', err);
      return {};
    }
  };

  useEffect(() => {
    const storeDataInSession = async () => {
      const data = await fetchDataFromCache();
      if (Object.keys(data).length > 0) {
        sessionStorage.setItem('userData', JSON.stringify(data));
        setDataFetchSuccess(true);
      }
    };

    if (!validNewCustomer) {
      storeDataInSession();
    }
  }, [validWithOTP]);


  useEffect(() => {
    if (localStorage.getItem('auth-token') == null) fetchToken();
  });

  return (
    <TokenCallContext.Provider value={{ data, fetchToken, dataFetchSuccess, currentUrl, setCurrentUrl }}>
      {children}
    </TokenCallContext.Provider>
  );

}

export const useTokenCallContext = () => {
  const context = useContext(TokenCallContext);
  if (context === undefined) {
    throw new Error('useTokenCallContext must be used within a TokenCallProvider');
  }
  return context;
};